import { AbstractControl, ValidationErrors } from '@angular/forms';

export function matchValuesValidator(
  matchTo: string
): (control: AbstractControl) => ValidationErrors | null {
  return (control: AbstractControl): ValidationErrors | null => {
    return !!control.parent &&
      !!control.parent.value &&
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      control.value === control.parent.controls[matchTo].value
      ? null
      : { mismatch: true };
  };
}
